export default __webpack_public_path__ + "static/media/fullLogo.30a91c2c.png";